module.exports = __webpack_public_path__ + "media/my_images/arrow-gold-adb83999db162ffb0676d8a23a77a104.svg";